import script from "./AppError.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppError.vue?vue&type=script&setup=true&lang=ts"

import "./AppError.vue?vue&type=style&index=0&id=3745a0b6&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3745a0b6"]])

export default __exports__